import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from 'axios';
import '../member.css';
export function Member() {
    let { email } = useParams();
    const [member, setMember] = useState({});
    useEffect(() => {
        //http://localhost:3001/member/
        //https://n2m4hmwxiw.us-east-1.awsapprunner.com/member
        axios.get('https://n2m4hmwxiw.us-east-1.awsapprunner.com/member/' + email)
            .then(async res => {
                console.log('response', res.data.message);
                setMember(res.data.message);
            })
            .catch(err => {
                console.log(err);
            });
    }, [email])
    return (
        <div>
            {console.log('member', member.householdMember?.firstName)}
            {
                member &&
                <div>
                    <div className="houseHold">
                        <label className="title">HouseHold</label><br /><br />
                        <div className="field">
                            <label className="fieldName">Name</label>
                            <label className="fieldValue">{member.householdMember?.firstName} {member.householdMember?.middleName} {member.householdMember?.firstName}</label>
                        </div>
                        <div className="field">
                            <label className="fieldName">Phone</label>
                            <label className="fieldValue">{member.householdMember?.phone} </label>
                        </div>
                        <div className="field">
                            <label className="fieldName">Email</label>
                            <label className="fieldValue">{member.householdMember?.email} </label>
                        </div>
                        <div className="field">
                            <label className="fieldName">Gender</label>
                            <label className="fieldValue">{member.householdMember?.gender} </label>
                        </div>
                        <div className="field">
                            <label className="fieldName">DOB</label>
                            <label className="fieldValue">{member.householdMember?.dob} </label>
                        </div>
                        <div className="field">
                            <label className="fieldName">Occupation</label>
                            <label className="fieldValue">{member.householdMember?.occupation} </label>
                        </div>
                        <div className="field">
                            <label className="fieldName">Employer Name</label>
                            <label className="fieldValue">{member.householdMember?.employerName} </label>
                        </div>
                    </div>
                    <div className="houseHold">
                        <div className="field address">
                            <label className="fieldName">Address</label>
                            <label className="fieldValue">{member.address?.addressLine2}, {member.address?.addressLine1}</label>
                        </div>
                    </div>
                </div>
            }
            {member?.spouse &&
                <div className="houseHold">
                    <label className="title">Spouse</label><br /><br />
                    <div className="field">
                        <label className="fieldName">Name</label>
                        <label className="fieldValue">{member.spouse?.firstName} {member.spouse?.middleName} {member.spouse.lastName}</label>
                    </div>
                    <div className="field">
                        <label className="fieldName">Phone</label>
                        <label className="fieldValue">{member.spouse?.phone}</label>
                    </div>
                    <div className="field">
                        <label className="fieldName">Email</label>
                        <label className="fieldValue">{member.spouse?.email}</label>
                    </div>
                    <div className="field">
                        <label className="fieldName">Gender</label>
                        <label className="fieldValue">{member.spouse?.gender}</label>
                    </div>
                    <div className="field">
                        <label className="fieldName">DOB</label>
                        <label className="fieldValue">{member.spouse?.dob}</label>
                    </div>
                    <div className="field">
                        <label className="fieldName">Occupation</label>
                        <label className="fieldValue">{member.spouse?.occupation}</label>
                    </div>
                    <div className="field">
                        <label className="fieldName">Employer</label>
                        <label className="fieldValue">{member.spouse?.employerName}</label>
                    </div>
                </div>
            }
            {
                member?.childrenInfo?.length > 0 &&
                <div className="houseHold">
                    <label className="title">Children</label><br /><br />
                    {
                        member?.childrenInfo?.map(
                            (child, index) =>
                            (
                                <div className="houseHold">
                                    <div className="field">
                                        <label className="fieldName">Name</label>
                                        <label className="fieldValue">{child.name}</label>
                                    </div>
                                    <div className="field">
                                        <label className="fieldName">DOB</label>
                                        <label className="fieldValue">{child.dob}</label>
                                    </div>
                                    <div className="field">
                                        <label className="fieldName">Gender</label>
                                        <label className="fieldValue">{child.gender}</label>
                                    </div>
                                </div>
                            )
                        )
                    }
                </div>
            }
        </div>
    )
}